import useMenu from '@/hooks/use-menu.hook';
import { Stack } from '@mui/material';

import { MenuItem } from '@mui/material';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  optionValue: string;
  optionLabel: ReactNode;
  endAdornment: ReactNode;
  disabled: boolean;
  onSelect: (value: string) => void;
}

const useStyles = createUseStyles({
  menuItem: {
    padding: '8px 16px',
  },
});

const ChipSelectItem: FC<Props> = ({
  optionValue,
  optionLabel,
  endAdornment,
  disabled,
  onSelect,
}) => {
  const closeMenu = useMenu();
  const styles = useStyles();
  const handleClick = () => {
    onSelect(optionValue);
    closeMenu?.();
  };

  return (
    <MenuItem
      key={optionValue}
      className={styles.menuItem}
      onClick={handleClick}
      disabled={disabled}
    >
      <Stack direction="row" alignItems="center" gap={0.5}>
        {optionLabel}
        {endAdornment}
      </Stack>
    </MenuItem>
  );
};

export default ChipSelectItem;
